import { Usps as UspsBase } from "@omni/components/components/Blocks/usps/usps";
import { useProductPageContext } from "@omni/components/components/ProductPage/context/productPage.context";
import { cn } from "@omni/utils/styles";

import { UspsComponent } from "@/components/Product/ProductPage/components/usps/usps.component";

export const Usps = () => {
    const { usps } = useProductPageContext();

    return (
        <UspsBase
            usps={usps}
            className={cn("tw:bg-grey tw:rounded-xl tw:p-4 tw:mb-8")}
        >
            <UspsComponent />
        </UspsBase>
    );
};
